import { useState, useEffect } from "react";
import api from "../services/api";

const useStoreItems = (user, loading) => {
  const [items, setItems] = useState([]);
  const [error, setError] = useState(null);

  useEffect(() => {
    if (!loading && user) {
      api
        .get("/store")
        .then((response) => {
          setItems(response.data);
        })
        .catch((error) => {
          setError(error);
          console.error("Erro ao buscar itens da loja:", error);
        });
    }
  }, [loading, user]);

  return { items, error };
};

export default useStoreItems;
